import script from "./PerguntasFrequentes.vue?vue&type=script&setup=true&lang=js"
export * from "./PerguntasFrequentes.vue?vue&type=script&setup=true&lang=js"

import "./PerguntasFrequentes.vue?vue&type=style&index=0&id=49910c46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49910c46"]])

export default __exports__